import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PublicServiceSection from './components/PublicServiceSection';
import ProductsSection from './components/ProductsSection';
import AtasSection from './components/AtasSection';
import CommitmentsSection from './components/CommitmentsSection';
import CTASection from './components/CTASection';
import ClientsSection from './components/ClientsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <AtasSection />
      <ProductsSection />
      <PublicServiceSection />
      <CommitmentsSection />
      <CTASection />
      <ClientsSection />
      <Footer />
    </main>
  );
}
